import { InjectionToken } from '@angular/core';

export interface Params {
  chainId: string;
  rpcUrls: string[];
  blockExplorerUrls: string[];
}

export interface Network {
  params: Params;
}

export interface Configuration {
  networks: Network[];
}

export const CONFIGURATION = new InjectionToken<Configuration>('NGX_ETH_WALLET_CONFIGURATION');
